import { atom } from 'jotai';

export const loadingConversationAtom = atom<boolean>(false);

interface ConversationPageState {
  isNewPage: boolean;
}

export const conversationPageStateAtom = atom<ConversationPageState>({
  isNewPage: true,
});
